var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRalvieLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 50,
    viewBox: "0 0 149.998 39.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.977,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#814d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d0b77"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ralvie_Logo",
    "data-name": "ralvie Logo",
    transform: "translate(-407.178 -362.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_105",
    "data-name": "Subtraction 105",
    d: "M17.171,39.625h0Zm-1.36-.053h0a17.011,17.011,0,0,1-6.2-1.7A17.181,17.181,0,0,1,1.316,15.849H11.888a3.962,3.962,0,1,1,0,7.925H4.321l2.438,3.353,1.4,1.931L15.81,39.572Zm5.035-.341h0L13.362,28.942a9.246,9.246,0,0,0-1.474-18.375H4.78A17.2,17.2,0,0,1,10.321,6.7a17.041,17.041,0,0,1,3.3-1.053,17.329,17.329,0,0,1,7.011-.019,17.074,17.074,0,0,1,6.14,2.584,17.223,17.223,0,0,1,6.221,7.555,17.063,17.063,0,0,1,1,3.223A17.185,17.185,0,0,1,26.21,37.056a17.036,17.036,0,0,1-5.364,2.175ZM19.152,3.963H15.189A1.981,1.981,0,0,1,13.788.58a1.968,1.968,0,0,1,1.4-.58h3.963a1.981,1.981,0,0,1,1.4,3.382A1.967,1.967,0,0,1,19.152,3.963Z",
    transform: "translate(407.178 362.997)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_407",
    "data-name": "Union 407",
    d: "M0,29.059V8.233H3.638v3.429a8.189,8.189,0,0,1,7.193-4.056v3.6a3.174,3.174,0,0,0-.627-.042c-3.972.126-6.565,2.76-6.565,6.858v11.04ZM81.626,17.93c0-6.365,4.468-11.128,10.622-11.128,6.449,0,10.2,5.059,10.2,10.411a8.943,8.943,0,0,1-.127,1.813H85.04a7.309,7.309,0,0,0,7.587,7,6.963,6.963,0,0,0,6.112-3.245l2.613,1.77a9.987,9.987,0,0,1-8.767,4.51C86.052,29.058,81.626,24.379,81.626,17.93Zm3.5-1.728H99.076C98.739,12.914,96.421,9.8,92.29,9.8A7.286,7.286,0,0,0,85.124,16.2ZM73.243,29.058V8.067H76.91V29.058ZM47.761,7.224H51.6L58.847,22.4,66.055,7.224h3.793L58.8,29.058ZM40.785,29.058V0h3.674V29.058Zm-10.013,0V24.3a9.25,9.25,0,0,1-8.178,4.763c-6.112,0-10.706-4.721-10.706-11.043C11.887,11.566,16.524,6.8,22.72,6.8a9.01,9.01,0,0,1,8.093,4.8l3.5-5.353v22.8ZM15.555,17.973a7.443,7.443,0,0,0,7.587,7.756,7.8,7.8,0,0,0,.084-15.6A7.532,7.532,0,0,0,15.555,17.973ZM72.358,2.74A2.725,2.725,0,0,1,75.056,0,2.79,2.79,0,0,1,77.8,2.74a2.782,2.782,0,0,1-2.74,2.7A2.689,2.689,0,0,1,72.358,2.74Z",
    transform: "translate(454.727 368.543)",
    fill: "#f8f8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalvieLogoDark);
export default __webpack_public_path__ + "static/media/ralvie_logo_dark.8b8b216e995a0304c760f2b00ad57d1c.svg";
export { ForwardRef as ReactComponent };